import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMaskFace = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.2 8H4.59067C4.03942 8 3.76379 8 3.55255 8.10569C3.35921 8.20242 3.20242 8.35921 3.10569 8.55255C3 8.76379 3 9.03942 3 9.59067V9.728C3 11.1692 3 11.8898 3.21315 12.5163C3.45355 13.2229 3.88684 13.8482 4.46405 14.3214C4.97584 14.7409 5.82994 15.0669 7.17937 15.573M17.8 8H19.4093C19.9606 8 20.2362 8 20.4474 8.10569C20.6408 8.20242 20.7976 8.35921 20.8943 8.55255C21 8.76379 21 9.03942 21 9.59067V9.728C21 11.1692 21 11.8898 20.7868 12.5163C20.5465 13.2229 20.1132 13.8482 19.536 14.3214C19.0242 14.7409 18.1929 15.036 16.8434 15.542M10 11H14M11 14H13M6 8V12C6 15.3137 8.68629 18 12 18C15.3137 18 18 15.3137 18 12V8H17.8028C17.2165 8 16.9233 8 16.6385 7.95881C16.2409 7.90131 15.8543 7.78423 15.4915 7.61153C15.2317 7.48782 14.9878 7.32521 14.5 7L13.8321 6.5547C13.2895 6.19301 12.6521 6 12 6C11.3479 6 10.7105 6.19301 10.168 6.5547L9.5 7C9.01218 7.32521 8.76827 7.48782 8.50846 7.61153C8.14573 7.78423 7.75906 7.90131 7.36145 7.95881C7.07666 8 6.78351 8 6.19722 8H6Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgMaskFace;
